module.exports = __webpack_public_path__ + "static/media/ahdb.3ebe017b.jpg";